const gradeArr = [
  {
    id: 0, // 이메일 인증만 했을 때
    title: "",
    type: "Normal",
  },
  {
    id: 1,
    title: "일반",
    type: "Normal",
  },
  {
    id: 2,
    title: "브론즈",
    type: "Bronze",
  },
  {
    id: 3,
    title: "실버",
    type: "Silver",
  },
  {
    id: 4,
    title: "플래티넘",
    type: "Platinum",
  },
  {
    id: 5,
    title: "다이아몬드",
    type: "Diamond",
  },
  {
    id: 6,
    title: "VIP",
    type: "VIP",
  },
  {
    id: 7,
    title: "VVIP",
    type: "VVIP",
  },
];

export { gradeArr };
